import { render } from "./AddGroup.vue?vue&type=template&id=065f2547&scoped=true&ts=true"
import script from "./AddGroup.vue?vue&type=script&lang=ts"
export * from "./AddGroup.vue?vue&type=script&lang=ts"

import "./AddGroup.vue?vue&type=style&index=0&id=065f2547&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-065f2547"]])

export default __exports__